import { unknownFreeBusy } from 'owa-locstrings/lib/strings/unknownfreebusy.locstring.json';
import { availableFreeBusy } from 'owa-locstrings/lib/strings/availablefreebusy.locstring.json';
import { showAsBusy } from 'owa-locstrings/lib/strings/showasbusy.locstring.json';
import loc from 'owa-localize';
import { LocationPersonaControlViewState } from 'owa-location-persona';
import { isFeatureEnabled } from 'owa-feature-flags';
import getRecurrenceAvailabilityTextAndStyle from './getRecurrenceAvailabilityTextAndStyle';

export default function getAvailabilityTextAndStyle(
    locationResult: LocationPersonaControlViewState,
    styles: any
): any {
    let freebusyStyle = styles.availabilityUnknown;
    let freebusyText = loc(unknownFreeBusy);

    const showRecurrenceAvailability: boolean =
        isFeatureEnabled('cal-mf-availabilityForRecurrence') &&
        !!locationResult.totalNumberOfTimeSlots;

    if (showRecurrenceAvailability) {
        const recurrenceTextAndStyle = getRecurrenceAvailabilityTextAndStyle(
            locationResult.numberOfAvailableTimeSlots,
            locationResult.totalNumberOfTimeSlots,
            locationResult.isPartialAvailability,
            styles.availabilityFree,
            styles.availabilityBusy
        );
        freebusyStyle = recurrenceTextAndStyle.textStyle;
        freebusyText = recurrenceTextAndStyle.text;
    } else if (locationResult.availability) {
        switch (locationResult.availability) {
            case 'Free':
                freebusyText = loc(availableFreeBusy);
                freebusyStyle = styles.availabilityFree;
                break;
            case 'Busy':
                freebusyText = loc(showAsBusy);
                freebusyStyle = styles.availabilityBusy;
                break;
        }
    }

    return { freebusyText, freebusyStyle };
}
